import type { Entry } from 'contentful';
import type { IContentPage } from '~~/lib/ContentfulService';

type HeroArticleSectionFields = {
  showReadingTime?: boolean;
};

/**
 * Reading time is toggled on {@link heroArticleSection} entries in `heroSections`,
 * not on the content page root fields.
 */
export function isContentPageReadingTimeEnabled(
  page: Pick<IContentPage, 'fields'>
): boolean {
  const heroSections = page.fields?.heroSections;
  if (!heroSections) {
    return false;
  }

  const sections: Entry<unknown>[] = Array.isArray(heroSections)
    ? heroSections
    : [heroSections];

  return sections.some((section: Entry<unknown>) => {
    if (section?.sys?.contentType?.sys?.id !== 'heroArticleSection') {
      return false;
    }

    const fields = section.fields as HeroArticleSectionFields | undefined;
    return Boolean(fields?.showReadingTime);
  });
}
